// used in the app, service and a copy is in clib
export enum FilterOperators {
  Begin = 'beginsWith',
  Blank = 'isBlank',
  Contain = 'contains',
  End = 'endsWith',
  Equal = 'equal',
  Greater = 'greaterThanOrEqual',
  Lesser = 'lessThanOrEqual',
  NotBlank = 'isNotBlank',
  NotContain = 'doesNotContain',
  NotEqual = 'notEqual'
}

export enum InSetFilterOperator {
  InSet = 'inSet',
  NotInSet = 'notInSet'
}

// used in the app, service and a copy is in clib
export enum BooleanOperators {
  And = 'and',
  Or = 'or'
}

export type IEqualFilter = {
  operator: FilterOperators.Equal;
  value: string | number;
  columnName: string;
};

export type IInSetFilter = {
  operator: InSetFilterOperator.InSet;
  value: string[] | number[];
  columnName: string;
};

export type IGreaterThanOrEqualFilter = {
  operator: FilterOperators.Greater;
  value: string | number;
  columnName: string;
};

export type ILessThanOrEqualFilter = {
  operator: FilterOperators.Lesser;
  value: string | number;
  columnName: string;
};

export type INotEqualFilter = {
  operator: FilterOperators.NotEqual;
  value: string | number;
  columnName: string;
};

export type IContainsFilter = {
  operator: FilterOperators.Contain;
  value: string;
  columnName: string;
};

export type IDoesNotContainFilter = {
  operator: FilterOperators.NotContain;
  value: string;
  columnName: string;
};

export type IIsBlankFilter = {
  operator: FilterOperators.Blank;
  columnName: string;
  value: void | null;
};

export type IIsNotBlankFilter = {
  operator: FilterOperators.NotBlank;
  columnName: string;
  value: void;
};

export type IBeginsWithFilter = {
  operator: FilterOperators.Begin;
  value: string;
  columnName: string;
};

export type IEndsWithFilter = {
  operator: FilterOperators.End;
  value: string;
  columnName: string;
};

export type IColumnFilterComparison =
  | IBeginsWithFilter
  | IContainsFilter
  | IDoesNotContainFilter
  | IEqualFilter
  | IGreaterThanOrEqualFilter
  | IInSetFilter
  | IIsBlankFilter
  | IIsNotBlankFilter
  | ILessThanOrEqualFilter
  | INotEqualFilter
  | IEndsWithFilter;

export type IColumnFilter = IColumnFilterComparison | IColumnFilterList;

export type ISegmentFilter = {
  label: string;
  segmentId: string;
  value: string;
};

export const createSegmentFilter = (values: Partial<ISegmentFilter> = {}): ISegmentFilter => ({
  label: null,
  segmentId: null,
  value: null,
  ...values
});

export type IColumnFilterList = {
  operator: BooleanOperators;
  value: IColumnFilter[];
  columnName?: string;
};

export type IColumnFilterOperator = IColumnFilterComparison['operator'];

export const createColumnFilter = (values: Partial<IColumnFilter> = {}): IColumnFilter => ({
  operator: null,
  value: null,
  columnName: null,
  ...values
});

export type IColumnFilterBooleanOperator = {
  booleanOperator: BooleanOperators;
  columnName: string;
};

export const createColumnFilterBooleanOperator = (
  values: Partial<IColumnFilterBooleanOperator> = {}
): IColumnFilterBooleanOperator => ({
  booleanOperator: undefined,
  columnName: undefined,
  ...values
});
